import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function ActualPrice(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Цена продажба';
    }

    const getType = () => {
        return 'actual_price';
    }

    const getTitle = () => {
        return 'Основна продажна цена';
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(ActualPrice)